// extracted by mini-css-extract-plugin
module.exports = {"css-transition":"Base_css-transition__UkPri","anchor":"Base_anchor__3iv6u"};